import { defineMessages } from 'react-intl';

export default defineMessages({
    addressNotFound: {
        id: 'address.lookup.component.Address.We were unable to find your address. Please enter your address manually.',
        defaultMessage: 'We were unable to find your address. Please enter your address manually.'
    },
    streetAddress: {
        id: 'address.lookup.component.streetAddress',
        defaultMessage: 'Where did the loss occur?'
    }
});
